"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _dualListControlled = _interopRequireDefault(require("../dual-list-controlled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getAssetDisplay = function getAssetDisplay(_, props) {
  return props && {
    hideCoupledAssets: props.hideCoupledAssets,
    showHistoricalAssets: props.showHistoricalAssets
  };
};

var assetSelector = (0, _reselect.createSelector)(_nicbaseReducers.getAssetInfos, _nicbaseReducers.getCoupledAssetInfos, _nicbaseReducers.getHistoricalCoupledAssetInfos, getAssetDisplay, function (assets, coupledAssets, historicalCoupledAssets, assetDisplay) {
  var mergedAssets = assets;

  if (!assetDisplay.hideCoupledAssets) {
    if (assetDisplay.showHistoricalAssets) {
      mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(historicalCoupledAssets));
    } else {
      mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(coupledAssets));
    }
  }

  return mergedAssets.reduce(function (result, _ref) {
    var id = _ref.id,
        name = _ref.name;
    result.push({
      id: id,
      label: name
    });
    return result;
  }, []);
});

var getAssetGroups = function getAssetGroups(state) {
  return state.assetInformationLists.assetGroups;
};

var assetGroupSelector = (0, _reselect.createSelector)(getAssetGroups, function (groups) {
  return groups.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name;
    return {
      id: id,
      label: name
    };
  });
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    assets: assetSelector(state, ownProps),
    assetGroups: assetGroupSelector(state)
  };
};

var AssetSelectionDualLists = function AssetSelectionDualLists(_ref3) {
  var allSelected = _ref3.allSelected,
      assets = _ref3.assets,
      assetGroups = _ref3.assetGroups,
      selectedAssets = _ref3.selectedAssets,
      selectedAssetGroups = _ref3.selectedAssetGroups,
      onChange = _ref3.onChange;

  var selectAssets = function selectAssets(items) {
    return onChange({
      selectedAssets: items.map(function (item) {
        return item.id;
      }),
      selectedAssetGroups: selectedAssetGroups,
      allSelected: allSelected
    });
  };

  var selectAssetGroups = function selectAssetGroups(items) {
    return onChange({
      selectedAssets: selectedAssets,
      selectedAssetGroups: items.map(function (item) {
        return item.id;
      }),
      allSelected: allSelected
    });
  };

  var deselectAssets = function deselectAssets(items) {
    var deselectedIds = items.map(function (item) {
      return item.id;
    });
    var filteredItems = selectedAssets.filter(function (id) {
      return !deselectedIds.includes(id);
    });
    onChange({
      selectedAssets: filteredItems,
      selectedAssetGroups: selectedAssetGroups,
      allSelected: allSelected
    });
  };

  var deselectAssetGroups = function deselectAssetGroups(items) {
    var deselectedIds = items.map(function (item) {
      return item.id;
    });
    var filteredItems = selectedAssetGroups.filter(function (id) {
      return !deselectedIds.includes(id);
    });
    onChange({
      selectedAssets: selectedAssets,
      selectedAssetGroups: filteredItems,
      allSelected: allSelected
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.assetSelection",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list-individually-selectable"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selected-assets"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "individual-selection-buttons-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': allSelected
    }),
    onClick: function onClick() {
      return onChange({
        selectedAssets: selectedAssets,
        selectedAssetGroups: selectedAssetGroups,
        allSelected: true
      });
    },
    key: "allButton"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.all",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': !allSelected
    }),
    raised: !allSelected,
    onClick: function onClick() {
      return onChange({
        selectedAssets: selectedAssets,
        selectedAssetGroups: selectedAssetGroups,
        allSelected: false
      });
    },
    key: "individualButton"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.selectIndividually",
    tagName: "span"
  }))), !allSelected && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mt-3 mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.AssetGroup, {
    className: "w-4 h-4 mr-1 fill-blue-500"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.assetGroups"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-blue-500"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_dualListControlled["default"], {
    selectableItems: assetGroups.filter(function (category) {
      return !selectedAssetGroups.includes(category.id);
    }),
    selectedItems: assetGroups.filter(function (category) {
      return selectedAssetGroups.includes(category.id);
    }),
    onSelectAll: selectAssetGroups,
    onSelect: selectAssetGroups,
    onDeselectAll: deselectAssetGroups,
    onDeselect: deselectAssetGroups,
    assignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.assigned",
      tagName: "span"
    }),
    notAssignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.notAssigned",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mt-3 mb-1 fill-blue-500"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
    className: "w-4 h-4 mr-1"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.assets"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-blue-500"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_dualListControlled["default"], {
    selectableItems: assets.filter(function (poi) {
      return !selectedAssets.includes(poi.id);
    }),
    selectedItems: assets.filter(function (poi) {
      return selectedAssets.includes(poi.id);
    }),
    onSelectAll: selectAssets,
    onSelect: selectAssets,
    onDeselectAll: deselectAssets,
    onDeselect: deselectAssets,
    assignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.assigned",
      tagName: "span"
    }),
    notAssignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.notAssigned",
      tagName: "span"
    })
  })))));
};

AssetSelectionDualLists.propTypes = {
  allSelected: _propTypes["default"].bool,
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  assetGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedAssets: _propTypes["default"].arrayOf(_propTypes["default"].number),
  selectedAssetGroups: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func
};
AssetSelectionDualLists.defaultProps = {
  allSelected: true,
  assets: [],
  assetGroups: [],
  selectedAssets: [],
  selectedAssetGroups: [],
  onChange: function onChange() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AssetSelectionDualLists);

exports["default"] = _default;